import {
  BaseProduct,
  BundleConfig,
  BundleItem,
  CartItem,
  Product,
} from "../models";
import { convertDataToCartItemFlattened } from "./DataConverters";

export const areBundleConfigsEqual = (
  currentBundleConfigs: BundleConfig,
  bundleConfigsToCheck: BundleConfig
): boolean => {
  const currentBundleTickets = currentBundleConfigs.bundleTickets || [];
  const bundleTicketsToCheck = bundleConfigsToCheck.bundleTickets || [];
  const currentBundleProducts = currentBundleConfigs.bundleProducts || [];
  const bundleProductsToCheck = bundleConfigsToCheck.bundleProducts || [];

  if (
    currentBundleTickets.length !== bundleTicketsToCheck.length ||
    currentBundleProducts.length !== bundleProductsToCheck.length
  ) {
    return false;
  }

  return (
    currentBundleTickets.every((currentBundleTicket: BaseProduct) => {
      return bundleTicketsToCheck.some((bundleTicketToCheck: BaseProduct) => {
        return (
          currentBundleTicket.ticketId === bundleTicketToCheck.ticketId &&
          currentBundleTicket.quantity === bundleTicketToCheck.quantity
        );
      });
    }) &&
    bundleTicketsToCheck.every((bundleTicketToCheck: BaseProduct) => {
      return currentBundleTickets.some((currentBundleTicket: BaseProduct) => {
        return (
          bundleTicketToCheck.ticketId === currentBundleTicket.ticketId &&
          bundleTicketToCheck.quantity === currentBundleTicket.quantity
        );
      });
    }) &&
    currentBundleProducts.every((currentBundleProduct: BaseProduct) => {
      return bundleProductsToCheck.some((bundleProductToCheck: BaseProduct) => {
        return (
          currentBundleProduct.productId === bundleProductToCheck.productId &&
          currentBundleProduct.quantity === bundleProductToCheck.quantity
        );
      });
    }) &&
    bundleProductsToCheck.every((bundleProductToCheck: BaseProduct) => {
      return currentBundleProducts.some((currentBundleProduct: BaseProduct) => {
        return (
          bundleProductToCheck.productId === currentBundleProduct.productId &&
          bundleProductToCheck.quantity === currentBundleProduct.quantity
        );
      });
    })
  );
};

export const getBundleItemQuantities = (product?: BaseProduct) => {
  if (!product || !product.bundleId)
    return { bundleProductQty: 0, bundleTicketQty: 0 };

  const calculateQuantity = (items: { quantity?: number }[] = []) =>
    items.reduce((acc, item) => acc + (item.quantity ?? 0), 0);

  const bundleProductQty = calculateQuantity(
    product.bundleConfigs?.parkProducts
  );
  const bundleTicketQty = calculateQuantity(product.bundleConfigs?.tickets);

  return { bundleProductQty, bundleTicketQty };
};

export const transformBundleConfigs = (
  bundleId?: number,
  bundleConfigs?: BundleConfig,
  response?: Product[]
) => {
  const bundleConfig = {
    ...bundleConfigs,
    bundleTickets: bundleConfigs?.tickets
      ?.map((item: BundleItem) => {
        const listProduct = response?.find(
          (p: Product) => p.ticketId === item.ticketId
        );
        if (listProduct) {
          return {
            ...listProduct,
            isBundle: true,
            bundleId: bundleId,
            quantity: item.quantity ?? 0,
          };
        }
        return {} as BaseProduct;
      })
      .filter((product: BaseProduct) => Object.keys(product).length > 0),
    bundleProducts: bundleConfigs?.parkProducts
      ?.map((item: BundleItem) => {
        const listProduct = response?.find(
          (p: Product) => p.productId === item.productId
        );
        if (listProduct) {
          return {
            ...listProduct,
            isBundle: true,
            bundleId: bundleId,
            quantity: item.quantity ?? 0,
            productOptions: [],
          };
        }
        return {} as BaseProduct;
      })
      .filter((product: BaseProduct) => Object.keys(product).length > 0),
  };

  return Object.values(bundleConfig).every((value) => value === undefined)
    ? undefined
    : bundleConfig;
};

export const flattenedBundleData = (bundle: CartItem) => {
  if (bundle.isBundle) {
    const tickets = bundle.bundleConfigs?.bundleTickets ?? [];
    const parkProducts = bundle.bundleConfigs?.bundleProducts ?? [];
    return convertDataToCartItemFlattened(tickets.concat(parkProducts));
  }
  return [];
};
